export default __webpack_public_path__ + "static/media/control-key.86da0f14.svg";